import React, { useEffect, useState } from 'react';
import '../styles/app/forms.css';

function OfflineBanner() {
  const [online, setOnline] = useState(typeof navigator === 'undefined' ? true : navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setOnline(true);
    const handleOffline = () => setOnline(false);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (online) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="pnp-sys-offline"
    >
      <span className="pnp-live-dot" aria-hidden="true" />
      <span>You're offline. Some features won't work until you reconnect.</span>
    </div>
  );
}

export default OfflineBanner;
